import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import PlanningHeadcountVacationsEditModal from './PlanningHeadcountVacationsEditModal';

class PlanningHeadcountsEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal_props: false,
      modal: false,
      loaded: 0,
      data_planning_headcount_id: '',
      planning_id: '',
      year: '',
      revision: '',
      date_start: '',
      date_finish: '',
      data_planning_headcount: [],
      data_planning_headcount_grade_vacation: [],
      planning_headcount_grades_list: [],
      staff_list: [],
      decimo_terceiro_types: [
        {value: "S", label: "S"},
        {value: "N", label: "N"},
      ]
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.add = this.add.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_planning_headcount.id !== 'undefined') {
        this.setState({
          planning_headcount_id: newProps.planning_headcount_id,
          data_planning_headcount: newProps.data_planning_headcount,
          planning_headcount_grade_vacations: newProps.planning_headcount_grade_vacations,
          planning_headcount_grades_list: newProps.planning_headcount_grades_list,
          staff_list: newProps.staff_list,
        });
      }
    }
  }

  loadData (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/planejamento/revisao/colaborador/info/edicao/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data_planning_headcount_grade_vacation: responseJson.data.main,
          });
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  refreshTable (value, event) {
    var self = this;
    var id = (value.id);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/planejamento/revisao/info/edicao/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data_planning_headcount: responseJson.data.main,
            planning_headcount_id: responseJson.data.main.id,
            planning_headcount_grade_vacations: responseJson.data.planning_headcount_grade_vacations,
            planning_headcount_grades_list: responseJson.data.planning_headcount_grades_list,
          });
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/planejamento/revisao/info/edicao/'+self.state.planning_headcount_id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data_planning_headcount: responseJson.data.main,
            planning_headcount_id: responseJson.data.main.id,
            planning_headcount_grade_vacations: responseJson.data.planning_headcount_grade_vacations,
            planning_headcount_grades_list: responseJson.data.planning_headcount_grades_list,
          });
          self.props.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      planning_id: this.props.data_planning_headcount.planning_id,
      planning_headcount_id: this.props.planning_headcount_id,
      planning_headcount_grade_id: this.state.planning_headcount_grade_id,
      staff_id: this.state.staff_id,
      decimo_terceiro: this.state.decimo_terceiro,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/planejamento/revisao/colaborador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({planning_headcount_grade_vacations: responseJson.data});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Edição - planejamento <small>Revisão: nº {this.state.revision} Ano: {this.state.year}</small></h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <PlanningHeadcountVacationsEditModal handleAlert={self.props.handleAlert} modal={self.state.modal_props} refreshTable={self.refreshTable} data_planning_headcount_grade_vacation={self.state.data_planning_headcount_grade_vacation} planning_headcount_id={self.state.planning_headcount_id} planning_headcount_grade_vacations={self.state.planning_headcount_grade_vacations} planning_headcount_grades_list={self.state.planning_headcount_grades_list} staff_list={self.state.staff_list} />
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-12 form-group">
                  <label>Mês:</label>
                  <Select
                    className="form-field-name"
                    name="planning_headcount_grade_id"
                    value={this.state.planning_headcount_grade_id}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'planning_headcount_grade_id')}
                    options={this.state.planning_headcount_grades_list}
                  />    
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Colaborador:</label>
                  <Select
                    className="form-field-name"
                    name="staff_id"
                    value={this.state.staff_id}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'staff_id')}
                    options={this.state.staff_list}
                  />    
                </div>
                <div className="col-md-6 form-group">
                  <label>Décimo Terceiro:</label>
                  <Select
                    className="form-field-name"
                    name="decimo_terceiro"
                    value={this.state.decimo_terceiro}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'decimo_terceiro')}
                    options={this.state.decimo_terceiro_types}
                  />    
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Data de início:</label>
                  <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
                </div>
                <div className="col-md-6 form-group">
                  <label>Data de fim:</label>
                  <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-success btn-lg btn-block">Adicionar <i className="fa fa-fw fa-plus"></i></button>
                </div>
              </div>
            </form>
            <hr/> 
            <h3 className="page-title">Lista de férias planejadas</h3>
            <hr/>
            {(this.state.planning_headcount_grade_vacations === null || typeof this.state.planning_headcount_grade_vacations === 'undefined') ?  <div><small><em>Nenhuma revisão cadastrada.</em></small><hr/></div> 
            : 
            <div>
              <table className="table table-bordered table-stripped table-hover">
                <thead>
                  <tr>
                    <th className="text-center">Mês</th>
                    <th className="text-center">Colaborador</th>
                    <th className="text-center">Função</th>
                    <th className="text-center">Base</th>
                    <th className="text-center">Quinzena</th>
                    <th className="text-center">Contratação</th>
                    <th className="text-center">Início</th>
                    <th className="text-center">Fim</th>
                    <th className="text-center">Qtd Dias</th>
                    <th className="text-center">Vencimento</th>
                    <th className="text-center">Limite</th>
                    <th className="text-center">Décimo terceiro</th>
                    <th className="col-md-1 text-center">Ações</th>
                  </tr>
                </thead>
                <tbody id="suppliers-certifications">
                  {Object.keys(self.state.planning_headcount_grade_vacations).map(function(k) {
                    return (
                      <tr>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].mes}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].staff}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].role}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].base}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].quinzena}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].contract}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].date_start_str}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].date_finish_str}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].qtd_dias_str}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].vencimento}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].limite}</td>
                        <td className="text-center">{self.state.planning_headcount_grade_vacations[k].decimo_terceiro}</td>
                        <td className="text-center">
                          <button onClick={self.loadData.bind(self, self.state.planning_headcount_grade_vacations[k])} className='btn btn-sm btn-primary' alt='Editar' title='Editar'><i className="fa fa-fw fa-pencil"></i></button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <hr/>
            </div>
            }
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PlanningHeadcountsEditModal;



// WEBPACK FOOTER //
// ./src/Components/Plannings/Elements/PlanningHeadcountsEditModal.js